import { GlobalStore, GridStore, ApiResponse } from '@roc/feature-app-core';
import { InsuranceDashboardInternalService } from '../services/insuranceDashboardService';
import { action, makeObservable, observable, computed } from 'mobx';
import { filterProps } from '@roc/ui';
import { InsuranceDashboardTab } from '../utils';

export class InsuranceDashboardStore {
  public globalStore: GlobalStore;
  protected insuranceDashboardService: InsuranceDashboardInternalService;
  public insuranceDashoboardGridStore: GridStore;
  public selectedTab: InsuranceDashboardTab =
    InsuranceDashboardTab.OLD_PIPELINE_UNREAD_TRACKING;
  public selectedRecords: number[];
  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.insuranceDashboardService = new InsuranceDashboardInternalService();
    this.insuranceDashoboardGridStore = new GridStore(() =>
      this.fetchRecords()
    );
    makeObservable(this, {
      selectedTab: observable,
      setSelectedTab: action,
      isQuoteDashboard: computed,
      setSelectedRecords: action,
    });
  }

  setSelectedTab(tab: InsuranceDashboardTab) {
    this.selectedTab = tab;
  }

  setSelectedRecords(record: number, selected: boolean): boolean {
    if (selected) {
      this.selectedRecords.push(record);
      return true;
    }
    if (record != null && !selected) {
      this.selectedRecords.filter(r => r != record);
    }
    return false;
  }

  async fetchRecords() {
    try {
      const response: ApiResponse = await this.insuranceDashboardService.getInsuranceDashbboard(
        this.getEnumKey(),
        this.insuranceDashoboardGridStore.gridData.meta.pageNumber,
        this.insuranceDashoboardGridStore.gridData.meta.pageSize,
        this.insuranceDashoboardGridStore.gridData.meta.sortDir,
        this.insuranceDashoboardGridStore.gridData.meta.sortBy,
        this.insuranceDashoboardGridStore.gridData.meta.filters,
        this.insuranceDashoboardGridStore.gridData.meta.dropdownFilters
      );
      return response;
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error fetching insurance records',
      });
    }
  }

  getEnumKey() {
    return Object.keys(InsuranceDashboardTab).find(
      key => InsuranceDashboardTab[key] == this.selectedTab
    );
  }

  get isQuoteDashboard() {
    // return [
    //   InsuranceDashboardTab.ALL_PENDING_QUOTES,
    //   InsuranceDashboardTab.MY_PENDING_QUOTES,
    // ].includes(this.selectedTab);
    return false;
  }

  getColumns(columns) {
    const filterOutFieldsOldPipeline = ['uploadedDate', 'hoursInReview'];
    const filterOutFields = ['insuranceApprovalStatus'];
    // if (this.selectedTab === InsuranceDashboardTab.OLD_PIPELINE) {
    //   const oldPipelineColumns = columns.filter(
    //     col => !filterOutFieldsOldPipeline.includes(col.field)
    //   );
    //   return [
    //     ...oldPipelineColumns,
    //     {
    //       field: 'lastInternalCommunication',
    //       headerName: 'Last Internal Communication',
    //       minWidth: 200,
    //       ...filterProps(),
    //     },
    //   ];
    // }
    return columns.filter(col => !filterOutFields.includes(col.field));
  }
}
